<template>
  <OfferTileList
    v-if="nonNullOffers"
    :offers="nonNullOffers"
  >
    <template #default="{ offer, index }">
      <OfferTileContainer
        v-if="offer.product"
        v-bind="offerTileContainerProps"
        :offer="offer"
        :tag-title="tagTitle"
        :lazy="alwaysLazy || index > 0"
        :has-cart-button="hasCartButton"
      />
    </template>
    <template #beforeOfferTiles>
      <slot name="beforeOfferTiles" />
    </template>
    <template #afterOfferTiles>
      <slot name="afterOfferTiles" />
    </template>
  </OfferTileList>
</template>

<script
  setup
  lang="ts"
  generic="O extends ListOffer | ScopedOffer<OfferQuery, ListQuery> = ListOffer"
>
import { OfferTileList } from '@i22team/td-longtail-vue-components';

import OfferTileContainer, {
  type OfferTileContainerProps,
} from '~/components/offer-tile-container.vue';

import type { ScopedOffer } from '@i22team/rocket';
import type { ListQuery, OfferQuery } from '#shared/types/goliath/goliath.types';

export type OfferTilesContainerProps<
  O extends ListOffer | ScopedOffer<OfferQuery, ListQuery> = ListOffer,
> = {
  offerTileContainerProps?: Partial<OfferTileContainerProps>;
  // GraphQL list items are nullable per-entry, so callers can pass Goliath's `entries` straight through.
  offers?: (O | null)[];
  alwaysLazy?: boolean;
  tagTitle?: string;
  hasCartButton?: boolean;
};

const props = withDefaults(defineProps<OfferTilesContainerProps<O>>(), {
  tagTitle: 'h2',
  offerTileContainerProps: undefined,
  offers: undefined,
});

const nonNullOffers = computed(() => props.offers?.filter((offer) => offer !== null));
</script>
